export const ACCESS_CHANGED_EVENT = "platform-access:changed";

const USER_MUTATIONS = new Set([
  "setTenantUserStatus", "setTenantUserRoles", "setTenantAdminStatus",
  "setTenantAdminRoles", "setPlatformAdminStatus", "setPlatformAdminRole",
]);
const TENANT_MUTATIONS = new Set([
  "updateTenantProfile", "uploadTenantLogo", "removeTenantLogo",
  "setTenantSystemAccess", "setTenantStatus",
]);

// Only successful, relevant mutations invalidate the display cache. Tenant
// switching and registrations already perform their own explicit refresh.
export function notifyAccessMutation(name, payload, user) {
  if (!user?.uid || typeof window === "undefined") return;
  if (USER_MUTATIONS.has(name) && payload?.uid === user.uid) {
    window.dispatchEvent(new CustomEvent(ACCESS_CHANGED_EVENT, { detail: { uid: user.uid } }));
  } else if (TENANT_MUTATIONS.has(name) && payload?.tenantId) {
    window.dispatchEvent(new CustomEvent(ACCESS_CHANGED_EVENT, {
      detail: { uid: user.uid, tenantId: payload.tenantId },
    }));
  }
}
